var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
import React from "react";
import { artWallCls, artWallWrapperCls, artWallImageWrapperCls, artWallLabelCls, artWallPersonCls } from "./WallPreview.less";
import personImage from "./images/person.png";
var DEFAULT_SCALE_VALUE = 0.92307;
var FIGURE_ACTUAL_HEIGHT = 180;
var ArtWallPreview = /* @__PURE__ */ function(_React$Component) {
  function ArtWallPreview2(props) {
    var _this;
    _classCallCheck(this, ArtWallPreview2);
    _this = _callSuper(this, ArtWallPreview2, [props]);
    _this.wrapperRef = /* @__PURE__ */ React.createRef();
    _this.state = {
      scaleValue: null,
      topPosition: null
    };
    return _this;
  }
  __name(ArtWallPreview2, "ArtWallPreview");
  _inherits(ArtWallPreview2, _React$Component);
  return _createClass(ArtWallPreview2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      if (!this.wrapperRef || !this.wrapperRef.current) {
        return;
      }
      var _this$props = this.props, imageWidth = _this$props.imageWidth, imageHeight = _this$props.imageHeight;
      var wrapperDimensions = this.wrapperRef.current.getBoundingClientRect();
      var precalcDimensions = {
        width: parseFloat(imageWidth) * DEFAULT_SCALE_VALUE,
        height: parseFloat(imageHeight) * DEFAULT_SCALE_VALUE
      };
      var scaledDimensions = {
        width: 0,
        height: 0
      };
      if (precalcDimensions.width > wrapperDimensions.width) {
        scaledDimensions.width = wrapperDimensions.width / imageWidth;
      }
      if (precalcDimensions.height > wrapperDimensions.height) {
        scaledDimensions.height = wrapperDimensions.height / imageHeight;
      }
      if (scaledDimensions.width || scaledDimensions.height) {
        var scaleValue;
        if (!scaledDimensions.height && scaledDimensions.width) {
          scaleValue = scaledDimensions.width;
        } else if (!scaledDimensions.width && scaledDimensions.height) {
          scaleValue = scaledDimensions.height;
        } else {
          scaleValue = scaledDimensions.width < scaledDimensions.height ? scaledDimensions.width : scaledDimensions.height;
        }
        var MIN_HEIGHT_DIFFERENCE = 40;
        var finalImageHeight = parseFloat(imageHeight * scaleValue);
        var heightDifference = wrapperDimensions.height > finalImageHeight ? parseInt(wrapperDimensions.height - finalImageHeight, 10) : 0;
        this.setState({
          scaleValue,
          topPosition: heightDifference > MIN_HEIGHT_DIFFERENCE ? heightDifference : null
        });
      }
    }, "componentDidMount")
  }, {
    key: "render",
    value: (
      /**
       * render
       */
      /* @__PURE__ */ __name(function render() {
        var _this$props2 = this.props, label = _this$props2.label, children = _this$props2.children;
        var _this$state = this.state, newScaleValue = _this$state.scaleValue, topPosition = _this$state.topPosition;
        var scale = newScaleValue || DEFAULT_SCALE_VALUE;
        return /* @__PURE__ */ React.createElement("div", {
          className: artWallCls
        }, /* @__PURE__ */ React.createElement("div", {
          className: artWallWrapperCls,
          ref: this.wrapperRef
        }, /* @__PURE__ */ React.createElement("div", {
          className: artWallImageWrapperCls,
          style: topPosition ? {
            top: "".concat(topPosition, "px")
          } : null
        }, typeof children === "function" && children(scale), label && /* @__PURE__ */ React.createElement("div", {
          className: artWallLabelCls
        }, label)), /* @__PURE__ */ React.createElement("img", _extends({
          src: personImage,
          alt: "",
          className: artWallPersonCls
        }, newScaleValue ? {
          style: {
            height: "".concat(FIGURE_ACTUAL_HEIGHT * newScaleValue, "px")
          }
        } : null))));
      }, "render")
    )
  }]);
}(React.Component);
export {
  ArtWallPreview
};
